import {
  BigIntWithDecimals,
  ChecksumAddress,
  LiquidationPriceLegacy,
  MerklRewardLegacy,
  PositionTypeLegacy,
} from "@silo/types";
import * as t from "io-ts";
import { BigIntFromString } from "io-ts-types";

/**
 * @deprecated
 */
export const PointsInfo = t.type({
  type: PositionTypeLegacy,
  label: t.string,
});

export type PointsInfo = t.TypeOf<typeof PointsInfo>;

/**
 * @deprecated
 */
export const PositionAsset = t.exact(
  t.type({
    assetAddress: ChecksumAddress,
    symbol: t.string,
    decimals: t.number,
    priceInUSD: t.union([
      t.type({
        value: BigIntFromString,
        decimals: t.number,
      }),
      t.null,
    ]),
    collateralBalance: BigIntFromString,
    collateralOnlyBalance: BigIntFromString,
    depositApr: BigIntFromString,
    depositRewardsApr: BigIntFromString,
    debtBalance: BigIntFromString,
    borrowApr: BigIntFromString,
    borrowRewardsApr: BigIntFromString,
    isBorrowAprFixed: t.boolean,
    isDisabledCollateral: t.boolean,
    liquidationPrice: LiquidationPriceLegacy,
    merklRewards: t.array(MerklRewardLegacy),
    points: t.array(PointsInfo),
    isProtectedOnly: t.boolean,
  })
);

/**
 * @deprecated
 */
export const Positions = t.exact(
  t.type({
    siloAddress: ChecksumAddress,
    siloSymbol: t.string,
    isSiloDeprecated: t.boolean,
    assets: t.array(PositionAsset),
    userLTV: BigIntFromString,
    userLiquidationThreshold: BigIntFromString,
    healthFactor: BigIntFromString,
    borrowingPowerUsed: BigIntFromString,
    isAtRiskOfLiquidation: t.boolean,
  })
);

export type Positions = t.TypeOf<typeof Positions>;
export type PositionAsset = t.TypeOf<typeof PositionAsset>;

export type UseAssetPriceInUSD = (
  assetAddress: ChecksumAddress
) => BigIntWithDecimals | undefined;
export type UseQuotePrice = () => BigIntWithDecimals | undefined;

export interface Links {
  disabledBorrowing: string;
  liquidationPrice: string;
  getDepositLink: GetActionLink;
  getBorrowLink: GetActionLink;
  getWithdrawLink: GetActionLink;
  getRepayLink: GetActionLink;
}

type GetActionLink = (
  siloAddress: ChecksumAddress,
  assetAddress?: ChecksumAddress
) => string;

export type BorrowState =
  | {
      _tag: "disabled";
    }
  | {
      _tag: "noBorrows";
    }
  | {
      _tag: "openBorrows";
      assets: PositionAsset[];
    };
